import React, { useEffect, useState} from 'react'
import {Card, Button, Typography, Alert, Box, TextField, CircularProgress} from '@mui/material'
import Axios from 'axios'
import {useParams} from 'react-router-dom'
import {Ingreso} from './Ingreso'
import {Loader} from './Loader'

export const Colaborador = ({noValidarUsuario})=>{
    const [usuario,setUsuario] = useState('') // Inicializado con '' para control de formulario
    const [tienePermiso,setTienePermiso] = useState(null)
    const [codigoEsValido,setCodigoEsValido] = useState(true)
    const [datosUsuario,setDatosUsuario] = useState(null)
    const [cargando,setCargando]= useState(true)
    const [validando,setValidando] = useState(false) // Nuevo estado para feedback del botón
    const parametros = useParams()

    useEffect(()=>{
        validarId()
    },[parametros.id])

    useEffect(()=>{
        if(noValidarUsuario){
            setTienePermiso(true)
            validarId()
        }
    },[])

    const validarId = async ()=>{
        try{
            const {data} = await Axios.get(process.env.NODE_ENV =='development' ? `http://localhost:3020/api/eventos/colaborador/acceso/${parametros.id}/${parametros.id_evento}`:`https://uadapi.uad.digital/api/eventos/colaborador/acceso/${parametros.id}/${parametros.id_evento}`)
            
            if (data?.resultado===1){
                setCodigoEsValido(true)
                setCargando(false)
            }else{
                setCodigoEsValido(false)
                setCargando(false)
            }
        }catch(err){
            setCodigoEsValido(false)
            alert(err?.response?.data?.message || 'Error de validación 1')
            setCargando(false)
        }
    }

    const validarUsuario = async ()=>{
        if (!usuario.trim()) return; // Previene envío vacío

        setValidando(true); // Activa el feedback de carga en el botón
        try{
            const {data} = await Axios.get(process.env.NODE_ENV =='development' ? `http://localhost:3020/api/eventos/colaborador/credencial/${parametros.id}/${usuario}/${parametros.id_evento}`:`https://uadapi.uad.digital/api/eventos/colaborador/credencial/${parametros.id}/${usuario}/${parametros.id_evento}`)
            
            if (data?.nombre){
                setTienePermiso(true)
                setDatosUsuario(data)
            }else{
                setTienePermiso(false)
                setDatosUsuario(null)
            }
        }catch(err){
            console.log(err)
            setTienePermiso(false)
            alert(err?.response?.data?.message || 'Error de validación 2')
        } finally {
            setValidando(false);
        }
    }
    
    // --- Renderizados Condicionales (Early Returns) ---

    if (cargando){
        return <Loader open={true} texto='Cargando...'/>
    }

    if (!codigoEsValido){
        return (
            <Box sx={{ p: 4, textAlign: 'center' }}>
                <Typography variant="h4" color="error" sx={{ fontWeight: 600 }}>
                    Error de Acceso
                </Typography>
                <Typography variant="subtitle1" sx={{ mt: 1 }}>
                    El link de colaborador no es válido o ha expirado.
                </Typography>
            </Box>
        )
    }

    if (tienePermiso===true && codigoEsValido){
        return (
            <Card sx={{ p: 4, maxWidth: 500, margin: '0 auto', textAlign: 'center' }}>
                <Typography variant="h5" color="primary" sx={{mb:2}}>
                    Acceso Autorizado
                </Typography>
                <Typography variant="h6" sx={{mt:1}}>
                    ¡Hola {datosUsuario?.nombre}!
                </Typography>
                <Box sx={{ mt: 3, p: 2, borderTop: '1px solid #ddd' }}>
                    <Ingreso codigo={parametros.id} usuario={datosUsuario} id_evento={parametros.id_evento}/>
                </Box>
            </Card>  
        )
    }

    // --- Formulario de Ingreso de Usuario ---
    return (
        <Card 
            sx={{
                // Estilos de Tarjeta Centrada y Responsiva
                maxWidth: { xs: '100%', md: 450 },
                margin: '30px auto',
                p: 4,
                boxShadow: 3, // Sombra sutil
                backgroundColor: '#f5f5f5', // Fondo ligero para destacar
                textAlign: 'center'
            }}
        >
            <Box 
                sx={{
                    display:'flex',
                    flexDirection:'column',
                    alignItems:'center',
                    gap: 3 // Espaciado vertical entre elementos
                }}
            >
                <Typography variant="h5" color="primary" sx={{ fontWeight: 700, mb: 1 }}>
                    Portal de Colaboradores
                </Typography>
                <Typography variant="body1" sx={{mb:1, color: 'text.secondary'}}>
                    Para continuar, por favor identifícate.
                </Typography>
                
                <TextField
                    label="Nombre de Usuario"
                    variant="outlined"
                    value={usuario}
                    placeholder="Escribe tu usuario aquí"
                    onChange={(e)=>setUsuario(e.target.value)}
                    fullWidth // Ocupa el 100% del Card (450px)
                    autoFocus
                    sx={{
                        backgroundColor: 'white' // Fondo blanco para el input
                    }}
                />
                
                <Button
                    variant="contained" 
                    color="primary" 
                    onClick={validarUsuario}
                    disabled={!usuario.trim() || validando} // Deshabilita si está vacío o validando
                    fullWidth
                    sx={{ height: 56 }} // Altura consistente
                >
                    {validando ? <CircularProgress size={24} color="inherit" /> : 'ACCEDER AL EVENTO'}
                </Button>

                {tienePermiso===false && 
                    <Alert 
                        sx={{ fontSize:'small', mt: 2 }} 
                        severity="error" // Usamos error para usuario inválido
                        variant='filled'
                    >
                        El nombre de usuario no es válido. Verifica las credenciales.
                    </Alert> 
                }
            </Box>
        </Card>
    )
}